import React from 'react';
import { PRICE_AMOUNT, PRICE_CURRENCY } from '../data/salesContent';
type PriceBlockProps = {
  lead?: string;
  notes?: string[];
  className?: string;
};
export function PriceBlock({
  lead,
  notes = [],
  className = ''
}: PriceBlockProps) {
  return <div className={`text-center ${className}`} data-id="element-47" data-mp="2ct075vga83t3">
      {lead && <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-zinc-400" data-id="element-48" data-mp="27x2qfo13wvfs">{lead}</p>}
      <p className="mt-1 font-display font-extrabold leading-none text-cyan-400" data-id="element-49" data-mp="1k7gs12sk6k8u">
        <span className="text-5xl md:text-6xl" data-id="element-50" data-mp="1g5muh3dntwcw">{PRICE_AMOUNT}</span>
        <span className="ml-2 text-2xl md:text-3xl" data-id="element-51" data-mp="1tw8g2zui0keh">{PRICE_CURRENCY}</span>
      </p>
      {notes.length > 0 && <p className="mt-3 text-sm font-medium text-zinc-300 md:text-base" data-id="element-52" data-mp="1p5ic9r1q0plw">{notes.join(' · ')}</p>}
    </div>;
}